// SHTicketCard.js
import React, { useState, useMemo } from 'react'
import './SHTicketCard.css'
import InputField from '../../../../components/InputField/InputField'
import { useLanguage } from '../../../../LanguageProvider'
import { CgCloseO } from 'react-icons/cg'
import { TbCaretDownFilled, TbCaretUpFilled} from "react-icons/tb";

const SHTicketCard = ({
    title,
    description,
    price,
    salesEnd,
    ticketInfos = [],
    onTicketChange,
    currency,
    isAdmin,
    removeTicket,
    type,
    ticket,
    ticketInfosMap,
    isSalesEnded
}) => {
    const sessionUserString = sessionStorage.getItem("user");
    const localUserString = localStorage.getItem("user");

    let userData = null;
    if (sessionUserString) {
        userData = JSON.parse(sessionUserString);
    } else if (localUserString) {
        userData = JSON.parse(localUserString);
    }

    const { getTranslation } = useLanguage()
    const count = ticketInfos.length
    const [showFullDesc, setShowFullDesc] = useState(false)
    const [hasAutofilledOnce, setHasAutofilledOnce] = useState(false);
    const toggleDescription = () => setShowFullDesc(prev => !prev)

    const descriptionPreview = description?.length > 100 && !showFullDesc
        ? description.slice(0, 120) + "..."
        : description

    // --- NEW: remaining inventory & canAdd guards ---
    const remaining = useMemo(() => {
        if (ticket?.trackInventory === "1") {
            const inv = Number(ticket?.inventory) || 0
            const sold = Number(ticket?.soldInventory) || 0
            const left = inv - sold
            return left > 0 ? left : 0
        }
        // no tracking -> treat as unlimited
        return Infinity
    }, [ticket])

    const canAdd = count < remaining

    const increment = () => {
        if (!canAdd) return;

        // Otomatik doldurulmuş bir bilet var mı? Tüm biletlerde kontrol et
        const anyAutoFilledExists = Object.values(ticketInfosMap).some(infos =>
            infos.some(info => info.email || info.name || info.lastname)
        );

        const shouldAutofill = !anyAutoFilledExists && userData?.email && !hasAutofilledOnce;

        if (shouldAutofill) {
            setHasAutofilledOnce(true);
        }

        const newInfo = shouldAutofill ? {
            name: userData.name || '',
            lastname: userData.lastname || '',
            email: userData.email || '',
            phone: userData.phone || '',
        } : {
            name: '',
            lastname: '',
            email: '',
            phone: '',
        };

        onTicketChange([
            ...ticketInfos,
            {
                ...newInfo,
                ticketType: type,
                ticketTitle: title,
                ticketPrice: price ? Number(price) : 0,
                ticketID: ticket.ticketID,
                channelID: ticket.channelID,
                eventID: ticket.eventID
            }
        ]);
    };

    const decrement = () => {
    if (count > 0) {
        const updated = ticketInfos.slice(0, -1);
        onTicketChange(updated);

        if (updated.length === 0) {
            setHasAutofilledOnce(false);
        }
    }
};

    const handleInputChange = (index, field, value) => {
        const newInfos = [...ticketInfos]
        newInfos[index] = { ...newInfos[index], [field]: value }
        onTicketChange(newInfos)
    }

    const clearRow = (index) => {
        const newInfos = [...ticketInfos]
        newInfos[index] = {
            ...newInfos[index],
            name: '',
            lastname: '',
            email: '',
            phone: ''
        }
        onTicketChange(newInfos)
        setHasAutofilledOnce(true);
    }

    const isRowEmpty = (info) => {
        return !(info?.name || info?.lastname || info?.email || info?.phone)
    }

    let ticketCount = (Number(ticket.inventory) || 0) - (Number(ticket.soldInventory) || 0)
    return (
        <div>
            <div className={`sh-ticket-card-container ${count > 0 ? "sh-ticket-card-container-selected" : ""}`}>
                <div className="sh-ticket-card-header">
                    <div className="sh-ticket-card-title">
                        <div className="sh-ticket-card-title-translation">{getTranslation("ticketContent")}</div>
                        <div className="sh-ticket-card-title-text">
                            {title} {(ticket.trackInventory === "1") &&
                                <>
                                    {ticketCount > 0 ? <span>(x{ticketCount})</span> : <span>({getTranslation("soldOut")})</span>}
                                </>
                            }
                        </div>
                    </div>
                    <div className="sh-ticket-card-price">
                        <div className="sh-ticket-card-price-label">{getTranslation("ticketPriceLabel")}</div>
                        <div className="sh-ticket-card-price-value">
                            {price ? price + " " + currency : getTranslation('free')}
                        </div>
                    </div>
                </div>

                <div className="sh-ticket-card-description">
                    {descriptionPreview}
                    {description?.length > 100 && (
                        <button
                            className="sh-ticket-card-showmore"
                            onClick={toggleDescription}
                        >
                            {showFullDesc ?
                                <span className="sh-ticket-card-description-carot">{getTranslation("showLess")} <TbCaretUpFilled /></span> :
                                <span className="sh-ticket-card-description-carot">{getTranslation("showMore")} <TbCaretDownFilled /> </span>
                            }

                        </button>
                    )}
                </div>

                <div className="sh-ticket-card-footer">
                    <div className="sh-ticket-card-actions">
                        {/* NEW: disabled + title for UX */}
                        <button
                            onClick={decrement}
                            className="sh-ticket-card-btn"
                            style={{ backgroundColor: 'transparent' }}
                            disabled={count === 0 || isSalesEnded}
                            title={count === 0 ? (getTranslation?.("nothingToRemove") || "Kaldırılacak kişi yok") : undefined}
                        >
                            −
                        </button>

                        <span className="sh-ticket-card-count">{count}</span>

                        <button
                            onClick={increment}
                            className="sh-ticket-card-btn"
                            disabled={!canAdd || isSalesEnded}
                            title={!canAdd && ticket?.trackInventory === "1"
                                ? getTranslation?.("noMoreInventory") || "Kalan envanter yok"
                                : undefined
                            }
                        >
                            +
                        </button>
                    </div>
                </div>

                {isAdmin === "1" &&
                    <span style={{ top: -10, right: -5, position: 'absolute' }}>
                        <CgCloseO
                            onClick={removeTicket}
                            style={{
                                backgroundColor: 'var(--logo-title)',
                                cursor: "var(--pointer)",
                                minWidth: "14px",
                                minHeight: "14px",
                                width: "14px",
                                height: "14px",
                                borderRadius: '50%',
                                color: '#ccc'
                            }}
                        />
                    </span>
                }
            </div>

            {ticketInfos.map((info, idx) => {
                const empty = isRowEmpty(info)
                return (
                    <div key={idx} className="sh-ticket-card-info-row">
                        {/* NEW: header row with clear text-button */}
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <p className='sh-speakers-title'>
                                {getTranslation('attendeeInfoForTicket')} #{idx + 1}
                            </p>
                            <button
                                type="button"
                                onClick={() => clearRow(idx)}
                                disabled={empty}
                                className='sh-speakers-title'
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    padding: 0,
                                    margin: 0,
                                    opacity: empty ? 0.5 : 1,
                                    cursor: empty ? 'not-allowed' : 'var(--pointer)',
                                    textDecoration: empty ? 'none' : 'underline'
                                }}
                                title={empty ? (getTranslation?.('nothingToRemove') || 'Temizlenecek alan yok') : (getTranslation?.('clear'))}
                            >
                                {getTranslation?.('clear') || 'Temizle'}
                            </button>
                        </div>

                        <div className="sh-ticket-card-input-group">
                            <InputField
                                style={{ backgroundColor: 'transparent', border: '1px solid var(--sh-ticket-card-border)' }}
                                placeholder={getTranslation("name")}
                                value={info.name}
                                onChange={e => handleInputChange(idx, 'name', e.target.value)}
                            />
                            <InputField
                                style={{ backgroundColor: 'transparent', border: '1px solid var(--sh-ticket-card-border)' }}
                                placeholder={getTranslation("lastname")}
                                value={info.lastname}
                                onChange={e => handleInputChange(idx, 'lastname', e.target.value)}
                            />
                        </div>
                        <div className="sh-ticket-card-input-group">
                            <InputField
                                style={{ backgroundColor: 'transparent', border: '1px solid var(--sh-ticket-card-border)' }}
                                placeholder={getTranslation("email")}
                                value={info.email}
                                onChange={e => handleInputChange(idx, 'email', e.target.value)}
                            />
                            <InputField
                                style={{ 
                                    backgroundColor: 'transparent', 
                                    border: '1px solid var(--sh-ticket-card-border)',
                                }}
                                maxLength={10}
                                placeholder={getTranslation("phone")}
                                value={info.phone}
                                onChange={e => handleInputChange(idx, 'phone', e.target.value)}
                            />
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default SHTicketCard